<template>
  <div class="agreement">
    <div class="info">
      <div class="dec">{{ info?.prescriptionNumber || 0 }}个合作协定方</div>
      <div class="sel" @click="sel">查看</div>
    </div>
    <a-drawer
      title="合作协定方"
      placement="right"
      v-model:visible="visible"
      :after-visible-change="afterVisibleChange"
      :width="420"
      @close="onClose"
      :body-style="{ padding: '0px' }"
    >
      <a-spin :spinning="loading">
        <div
          v-if="list.length > 0"
          style="height: calc(100vh - 60px); overflow-y: scroll; padding: 20px"
        >
          <div v-for="(item, index) in list" :key="index" style="margin-bottom: 15px">
            <GoodsCard
              :name="item.prescriptionName"
              :description="`¥${item?.chinesePrescriptionInfo?.price || '0.00'}/${
                item?.usageDosage?.cycle
              }${item?.usageDosage?.cycleUnit}`"
              @selInfo="selInfo(item)"
            >
              <template #name>
                <!-- relationDoctor 1:科室 0 是自研 -->
                <auth-img class="img" :src="item?.relationDoctor === 1 ? ksImage : zyImg" />
              </template>
              <template #content>
                <div
                  class="content elip--multiple"
                  v-for="(iItem, iIndex) in items(item)"
                  :key="iIndex"
                >
                  <span class="c-title">{{ iItem.label }}</span>
                  <span class="c-content">
                    {{ iItem.value || '--' }}
                  </span>
                </div>
              </template>
            </GoodsCard>
          </div>
        </div>
        <a-empty v-else />
      </a-spin>
    </a-drawer>
    <!-- 详情 -->
    <Info ref="infoRef"></Info>
  </div>
</template>
<script setup>
import zyImg from '@/assets/img/chat/agreement/zyImg.png'
import ksImage from '@/assets/img/chat/agreement/ksImage.png'
import { ref, defineProps } from 'vue'
import GoodsCard from './GoodsCard.vue'
import { getAgreementList } from '@/api/workPlace/agreement'
import { items } from './config'
import Info from './Info.vue'
const visible = ref(false)
const list = ref([])
const infoRef = ref()
const props = defineProps({
  ucDoctorId: {
    type: String,
    default: ''
  },
  info: {
    type: Object,
    default: () => {}
  }
})
const loading = ref(false)
const selInfo = info => {
  const { prescriptionSn = '' } = info
  infoRef?.value?.initData({ prescriptionSn })
}
const getList = () => {
  loading.value = true
  try {
    const params = {
      ucDoctorId: props.ucDoctorId
    }
    getAgreementList(params)
      .then(res => {
        console.log('res===', res)
        list.value = res
      })
      .finally(() => {
        loading.value = false
      })
  } catch (error) {
    loading.value = false
  }
}
const sel = () => {
  visible.value = true
  getList()
}
const afterVisibleChange = () => {
  console.log('visible', visible.value)
}
const onClose = () => {
  visible.value = false
  console.log('Clicked cancel button')
}
</script>

<style lang="scss" scoped>
.number {
  max-width: 67px;
}
.img {
  margin-left: 6px;
  height: 22px;
}
.content {
  margin-top: 7px;
  color: #666666;
  font-size: 14px;
  -webkit-line-clamp: 1;
}
.content:last-child {
  margin-bottom: 0;
}
.agreement {
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 8px 14px;
    .dec {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    .sel {
      cursor: pointer;
      font-weight: 400;
      font-size: 12px;
      color: #014ea8;
    }
  }
}
</style>
